import './style.css';
import { Map, View } from 'ol';
import { fromLonLat } from 'ol/proj.js';
import { DragPan, MouseWheelZoom, defaults } from 'ol/interaction.js';
import { platformModifierKeyOnly, mouseOnly, touchOnly } from 'ol/events/condition.js';
import { apply } from 'ol-mapbox-style';
import Overlay from 'ol/Overlay.js';
import Vector from 'ol/source/Vector.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Style from 'ol/style/Style.js';
import Icon from 'ol/style/Icon.js';
import VectorLayer from 'ol/layer/Vector.js';
import { Attribution, defaults as defaultControls } from 'ol/control.js';
import { equals } from 'ol/extent';

// console.log(mapConfig);

const map = new Map({
  interactions: defaults({ dragPan: false, mouseWheelZoom: false }).extend([
    new DragPan({
      condition: function (event) {
        // Überprüfen, ob die Aktion von einem Touch-Gerät mit zwei Fingern oder von einer Maus ausgeführt wird
        return platformModifierKeyOnly(event) || // Strg-Taste gedrückt
          mouseOnly(event) || // Nur Mausaktionen zulassen
          (touchOnly(event) && this.getPointerCount() === 2); // Nur Touch mit zwei Fingern
      },
    }),
    new MouseWheelZoom({
      condition: platformModifierKeyOnly,
    }),
  ]),
  target: 'map',
  view: new View({
    center: fromLonLat([mapConfig.coordInfo.coordInfo0.lon, mapConfig.coordInfo.coordInfo0.lat]),
    minZoom: mapConfig.minZoom,
    zoom: mapConfig.zoomInitial
  })
});

// ==== Overlay Hinweis
// Overlay für Hinweise hinzufügen
var hintOverlay = document.createElement('div');
hintOverlay.classList.add('hint-overlay');
/* hintOverlay.style.position = 'absolute';
hintOverlay.style.bottom = '10px';
hintOverlay.style.left = '10px';
hintOverlay.style.padding = '5px';
hintOverlay.style.background = 'rgba(255, 255, 255, 0.7)';
hintOverlay.style.borderRadius = '5px'; 
hintOverlay.style.display = 'none'; */
document.getElementById('map').appendChild(hintOverlay);

// Funktion zum Anzeigen des Hinweises
function showHint(message) {
  hintOverlay.innerText = message;
  // hintOverlay.style.display = 'block';

  hintOverlay.classList.add('hint-overlay-active');

  /*// Hinweis nach 3 Sekunden ausblenden
  setTimeout(function () {
    hintOverlay.style.display = 'none';
  }, 500); */

  // Hinweis ausblenden
  setTimeout(function () {
    hintOverlay.classList.remove('hint-overlay-active');
  }, 750);
}

// Event-Listener für Zoom-Versuche ohne Strg-Taste
map.on('wheel', function (event) {
  if (!platformModifierKeyOnly(event)) {
    showHint('Zum Zoomen Strg-Taste gedrückt halten');
    event.preventDefault();
  }
});

// Event-Listener für Verschieben mit einem Finger auf Touch-Geräten
var hintTimeout; // Variable zur Speicherung des Timeout, um ihn ggf. abbrechen zu können

// Verbessern Sie die Logik im touchstart Event-Listener
map.getViewport().addEventListener('touchstart', function (event) {
  // Abbrechen des vorherigen Timeout, wenn vorhanden
  if (hintTimeout) {
    clearTimeout(hintTimeout);
    hintTimeout = null;
  }

  // Setzen des Timeout nur, wenn genau ein Finger verwendet wird
  if (event.touches.length === 1) {
    hintTimeout = setTimeout(function () {
      let touch = event.touches[0];
      let pixel = map.getEventPixel(touch);
      let hitFeature = map.forEachFeatureAtPixel(pixel, function (feature) {
        return feature.get('isMarker');
      });
      let hitControl = document.elementFromPoint(touch.clientX, touch.clientY).closest('.ol-control') != null;
      let hitPopup = document.elementFromPoint(touch.clientX, touch.clientY).closest('#popup') != null;

      // Hinweis anzeigen, wenn kein Marker, kein Popup und kein Control-Element getroffen wurde und immer noch nur ein Finger im Spiel ist
      if (!hitFeature && !hitControl && !hitPopup && event.touches.length === 1) {
        showHint('Zum Verschieben zwei Finger verwenden');
      }
    }, 500); // Verzögerung von 500 Millisekunden
  }
}, { passive: false });

// Verhindern, dass der Hinweis angezeigt wird, wenn ein zweiter Finger hinzugefügt wird
map.getViewport().addEventListener('touchend', function (event) {
  if (event.touches.length > 1 && hintTimeout) {
    clearTimeout(hintTimeout);
    hintTimeout = null;
  }
});

/* map.getViewport().addEventListener('touchstart', function (event) {
  // Bestehenden Timeout abbrechen, wenn er existiert (um zu verhindern, dass der Hinweis angezeigt wird, wenn schnell ein zweiter Finger hinzugefügt wird)
  if (hintTimeout) {
    clearTimeout(hintTimeout);
    hintTimeout = null;
  }

  if (event.touches.length === 1) {
    // Verzögerung vor dem Anzeigen des Hinweises setzen
    hintTimeout = setTimeout(function () {
      // Überprüfen, ob immer noch nur ein Finger verwendet wird
      if (event.touches.length === 1) {
        showHint('Zum Verschieben zwei Finger verwenden');
      }
    }, 500); // Verzögerung von 500 Millisekunden
  }
}, { passive: false }); */


// ==== Apply Vector Style
apply(map, mapConfig.styleJsonPath).then(function () {

  // Prüfen, ob ein Attribution-Control vorhanden ist und es entfernen
  let attributionControl = map.getControls().getArray().find(control => control instanceof Attribution);
  if (attributionControl) {
    map.removeControl(attributionControl);
  }

  // Ein neues Attribution-Control mit collapsible: false erstellen und zur Karte hinzufügen
  attributionControl = new Attribution({
    collapsible: mapConfig.attribution.collapsible
  });
  map.addControl(attributionControl);

  var layer = map.getLayers().getArray()[0]; // Angenommen, Ihr Style bezieht sich auf die erste Ebene
  var source = layer.getSource();
  source.setAttributions(mapConfig.attribution.content + ' © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> Mitwirkende');

  // Popup-Logik
  var container = document.getElementById('popup');
  var content = document.getElementById('popup-content');
  var closer = document.getElementById('popup-closer');

  var overlay = new Overlay({
    element: container,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });
  map.addOverlay(overlay);

  closer.onclick = function () {
    overlay.setPosition(undefined);
    closer.blur();
    return false;
  };

  // Marker und Popup-Logik
  var vectorSource = new Vector({});

  var markerInfo = [];
  // Iteriere durch das coordInfo-Objekt
  for (var key in mapConfig.coordInfo) {
    if (mapConfig.coordInfo.hasOwnProperty(key)) {
      var coord = mapConfig.coordInfo[key];
      // Füge die Marker-Information in das markerInfo Array ein
      markerInfo.push({
        coord: [coord.lon, coord.lat], // Beachte die Reihenfolge: zuerst Längengrad, dann Breitengrad
        content: coord.content
      });
    }
  }

  markerInfo.forEach(function (info) {
    var marker = new Feature({
      geometry: new Point(fromLonLat(info.coord)),
      // Speichern des Inhalts in der Feature, um ihn später für das Popup zu nutzen
      content: info.content,
      isMarker: true // Hinzufügen der Marker-Identifikation
    });

    var iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 46],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: mapConfig.defaultIconPath,
      }),
    });

    marker.setStyle(iconStyle);
    vectorSource.addFeature(marker);
  });

  var markerLayer = new VectorLayer({
    source: vectorSource,
  });

  map.addLayer(markerLayer);


  // Marker Cursor Pointer zuweisen
  map.on('pointermove', function (e) {
    // Überprüfen, ob der Mauszeiger über einem Feature liegt
    var pixel = map.getEventPixel(e.originalEvent);
    var hit = map.hasFeatureAtPixel(pixel, {
      layerFilter: function (layer) {
        // Filtern, um nur Marker-Layer zu berücksichtigen, falls nötig
        return layer === markerLayer; // Angenommen markerLayer ist Ihr Marker Layer
      }
    });

    map.getTargetElement().style.cursor = hit ? 'pointer' : '';
  });




  map.on('singleclick', function (event) {
    var featureFound = false; // Variable zum Verfolgen, ob ein Feature gefunden wurde
    map.forEachFeatureAtPixel(event.pixel, function (feature) {
      var coord = feature.getGeometry().getCoordinates();
      var contentHtml = feature.get('content'); // Zugriff auf den gespeicherten Inhalt
      if (contentHtml) { // Überprüfen, ob der Inhalt existiert
        // Überprüfen, ob das Popup bereits an dieser Position geöffnet ist
        if (overlay.getPosition() && equals(overlay.getPosition(), coord)) {
          overlay.setPosition(undefined); // Wenn ja, Popup schließen
          featureFound = true; // Verhindern, dass das Popup erneut geöffnet wird
        } else {
          content.innerHTML = contentHtml;
          overlay.setPosition(coord); // Wenn nein, Popup an neuer Position öffnen
          featureFound = true;
        }
      }
    }, {
      layerFilter: function (layer) {
        return layer === markerLayer; // Stellen Sie sicher, dass nur Features innerhalb des MarkerLayers geprüft werden
      }
    });

    // Wenn außerhalb eines Markers geklickt wurde und kein Feature gefunden wurde, das Popup schließen
    if (!featureFound) {
      overlay.setPosition(undefined);
    }
  });

  // Anpassen der Karte, um alle Marker anzuzeigen
  if (vectorSource.getFeatures().length > 1) {
    map.getView().fit(vectorSource.getExtent(), { padding: [60, 60, 20, 60], minResolution: 0.5 });
  } else if (vectorSource.getFeatures().length === 1) {
    map.getView().setCenter(vectorSource.getFeatures()[0].getGeometry().getCoordinates());
    map.getView().setZoom(mapConfig.zoomInitial);
  }




});